<template>
  <div>
    <div class="row">
      <div class="col">
        <h4 class="mb-4 font-weight-normal h3">{{ t('support.welcome_heading') }}!</h4>
        <p class="mb-4"><b>{{ t('support.for_safety_reasons') }}:</b> {{ t('support.request_email_code') }}.</p>
        <p class="mb-4"><b>{{ t('fmc5.step') }} 1:</b></p>
        <div class="row">
          <div class="col-12 col-sm-4">
            <div class="mb-4">
              <label for="order_email">{{ $t('support.enter_email') }}</label>
              <div class="input-group">
                <input ref="email" type="email" id="order_email" name="email" class="form-control"
                       @input="$emit('update:email', $event.target.value)"
                       @change="showEmailError=false"
                       @keyup.enter="requestCode"
                       :value="email"
                       :disabled="approvedEmail"
                       required>
                <div class="invalid-feedback">
                  {{ $t('support.email_required') }}
                </div>
              </div>
              <a v-if="approvedEmail" @click="resendCode" class="text-primary clickable">Resend</a>
            </div>
          </div>
        </div>
        <div class="d-block d-sm-inline-block mb-4">
          <button
            v-if="!approvedEmail"
            class="btn btn-success"
            type="button"
            @click.prevent="requestCode"
            :disabled="!canRequestCode || submitting"
          >
            {{ $t('support.request_code') }}
          </button>
          <p v-else>
            {{ emailResponse }}
          </p>
        </div>
      </div>
    </div>
    <div v-if="approvedEmail" class="row">
      <div class="col">
        <p class="mb-4"><b>{{ t('fmc5.step') }} 2:</b></p>
        <div class="row">
          <div class="col-12 col-sm-4">
            <div class="mb-4">
              <label for="order_code">{{ $t('support.code') }}</label>
              <div class="input-group">
                <input
                  ref="code"
                  type="text"
                  required
                  @change="showEmailError=false"
                  pattern="[0-9]{6}"
                  id="order_code"
                  name="code"
                  class="form-control"
                  @input="$emit('update:code', $event.target.value)"
                  @keyup.enter="$emit('submit')"
                  :value="code">

                <div class="invalid-feedback" v-if="showEmailError">
                  {{ $t('support.code_required') }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-block d-sm-inline-block">
          <button class="btn btn-success d-inline-flex align-items-center " type="button" @click="$emit('submit')" :disabled="submitDisabled">
            {{ $t('support.get_order_status') }}
            <span v-show="submitDisabled" class="position-relative pr-5">
              <preloader size="xs"/>
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Cleave from "cleave.js";
import Preloader from './Preloader';
import {t} from '../utils/i18n';

export default {
  name: "OrderStatusForm",
  components: {
    Preloader
  },
  props: {
    email: {
      type: String,
      required: false,
      default: null
    },
    code: {
      type: String,
      required: false,
      default: null
    },
    submitDisabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      approvedEmail: false,
      showEmailError: false,
      submitting: false,
      emailResponse: ""
    }
  },
  computed: {
    canRequestCode() {
      return (this.email && this.email.length > 0) && !this.showEmailError;
    }
  },
  api: {
    async requestCode(email) {
      return await fetch('/request-support-code', {
        method: 'post',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
          email
        }),
      }).then(resp => {
        return resp.json();
      });
    }
  },
  methods: {
    t(key) {
      return t(key);
    },
    async resendCode() {

      const response = await this.$options.api.requestCode(this.email)

      if (response.status != 1) {
        this.$emit('error', response);
      } else {
        this.approvedEmail = true;
      }
    },
    async requestCode() {
      if (!this.canRequestCode || this.submitting) {
        return;
      }
      this.$emit('reset-alert');
      this.emailResponse = "";

      if (!this.email || !this.validateEmail()) {
        this.showEmailError = true;
        return false;
      } else {
        this.showEmailError = false;
      }

      this.submitting = true;

      const response = await this.$options.api.requestCode(this.email)

      this.submitting = false;

      if (response.status != 1) {
        this.$emit('error', response);
      } else {
        this.emailResponse = response.message;
        this.approvedEmail = true;
      }
    },
    validate() {
      return this.validateEmail() && this.validateCode();
    },
    validateEmail() {
      return this.$refs['email'].checkValidity();
    },
    validateCode() {
      return this.$refs['code'].checkValidity();
    },
  },
  created(){
    if (this.email) {
      this.approvedEmail = true;
    }
  },
  mounted() {
    js_deps.wait_for(() => {
      return !!document.getElementById('order_code');
    }, () => {
      new Cleave('#order_code', {
        numericOnly: true,
        blocks: [6]
      });
    });
  }
}
</script>
<style lang="scss">

</style>